import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { DateHandler, KeyEventUtil } from 'utils'

const FechaFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  values,
  index,
  handleChange,
  setValues,
  actualizarFilaHandler,
  fechaEmisionDocumento
}) => {
  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`input-monto-cuota-${index}`, e)
    },
    [index]
  )

  const onInputChange = React.useCallback(
    e => {
      handleChange(e)
      const nuevaFecha = e.target.value
      values.fecha = nuevaFecha

      if (DateHandler.isValidString(nuevaFecha)) {
        let plazoDias = ''

        if (values.fecha) {
          const fechaHoy = DateHandler.parse(fechaEmisionDocumento)
          const fechaCuota = DateHandler.parse(values.fecha)

          const diasDiferencia = DateHandler.differenceInDays(fechaCuota, fechaHoy)
          plazoDias = diasDiferencia
        }

        values.plazoDias = plazoDias
      }

      actualizarFilaHandler({ index: index, rowData: values })

      setValues(values)
    },
    [handleChange, values, setValues, actualizarFilaHandler, index, fechaEmisionDocumento]
  )

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='fecha'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id={`date-fecha-cuota-${index}`}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onChange={onInputChange}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFormGroup)
